import { render, staticRenderFns } from "./Pannel.vue?vue&type=template&id=4b728572&scoped=true&"
import script from "./Pannel.vue?vue&type=script&lang=js&"
export * from "./Pannel.vue?vue&type=script&lang=js&"
import style0 from "./Pannel.vue?vue&type=style&index=0&id=4b728572&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b728572",
  null
  
)

export default component.exports